import React from 'react';
import './index.css';
import { render } from 'react-dom';
import { App } from './App';
const rootElement = document.getElementById('root');
if (rootElement) {
  render(<App data-id="element-171" />, rootElement);
}